import { ArrowRight, Users } from "lucide-react";
import { FadeIn } from "@/components/Reveal";
import { SKOOL_URL } from "@/data/content";

export default function Newsletter() {
  return (
    <section className="mx-auto max-w-7xl px-6 pb-24 md:px-12 md:pb-32">
      <FadeIn>
        <div className="relative overflow-hidden rounded-[2.5rem] bg-forest px-8 py-16 text-cream md:px-16 md:py-24">
          <div className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-gold/15 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 -left-16 h-72 w-72 rounded-full bg-sky/15 blur-3xl" />
          <div className="relative max-w-2xl">
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">The Journey Continues</p>
            <h2 className="mt-4 font-serif text-4xl leading-tight tracking-tight md:text-5xl">Join the Journey</h2>
            <p className="mt-4 text-base leading-relaxed text-cream/75 md:text-lg">
              New chapters, artwork reveals, and first dibs on every book. Our story club lives on Skool, and everyone's invited.
            </p>
            <a
              href={SKOOL_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="newsletter-skool-button"
              className="group mt-8 inline-flex h-14 items-center justify-center gap-3 rounded-full bg-gold px-8 text-sm font-semibold uppercase tracking-widest text-charcoal transition-transform duration-300 hover:scale-[1.03]"
            >
              <Users size={17} /> Join the Group on Skool
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
            </a>
          </div>
        </div>
      </FadeIn>
    </section>
  );
}
